import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  RiListSettingsLine,
  RiLockPasswordLine,
  RiProfileFill,
} from "react-icons/ri";
import { VscActivateBreakpoints, VscDiffAdded } from "react-icons/vsc";
import { FiClock } from "react-icons/fi";
import { BiCube } from "react-icons/bi";    
import { FaIndustry } from "react-icons/fa";
import { AiOutlineForm, AiOutlineMail } from "react-icons/ai";
import { MdSms, MdAssignmentAdd, MdMapsHomeWork, MdRefresh } from "react-icons/md";
import { IoIosNotifications } from "react-icons/io";
import { BiLogOut } from "react-icons/bi";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { logOut } from "../../features/admin/adminAuth/adminAuthSlice";
import { CiUser } from "react-icons/ci";
import { HiUserGroup } from "react-icons/hi";
import { hasAdminPermission, isSuperAdmin } from "../../utils/hasAdminPermission";
export default function Navbar() {
  const dispatch = useDispatch();
  const logout = () => {
    toast(
      (t) => (
        <span>
          <h6>
            Are you sure you want to <b>Logout ?</b>
          </h6>
          <div className="mt-3 d-flex">
            <button
              className="btn btn-outline-danger btn-sm ml-auto mr-1"
              onClick={() => {
                sessionStorage.clear();
                dispatch(logOut());
                window.location.href = "/";
              }}
            >
              Yes
            </button>
            <button
              className="btn btn-outline-primary btn-sm mr-auto ml-1"
              onClick={() => {
                toast.dismiss(t.id);
              }}
            >
              No
            </button>
          </div>
        </span>
      ),
      {
        id: "logout",
      }
    );
    return;
  };

  const location = useLocation();
  const [pathname, setPathname] = useState(location.pathname.split("/")[1]);

  useEffect(() => {
    const pathname = location.pathname.split("/")[1];
    setPathname(pathname);
  }, [location]);

  const sidebarOptions = {
    type: "Admin",
    item: [

      { title: "Onboarding / Setup", heading: true },
      { title: "Clients",               path: "",                     permission: "clients",              icon: <BiCube />,            heading: false },
      { title: "App Setup (Client)",    path: "clientAppSetup",       permission: "appMenu",              icon: <RiListSettingsLine />,heading: false },
      { title: "Form Setup (Client)",   path: "formSetupByClient",    permission: "formsetup",            icon: <MdAssignmentAdd />,   heading: false },
      { title: "Tenant Sidebar Setup",  path: "tenantSidebar",        permission: "tenantSidebar",        icon: <VscDiffAdded />,      heading: false },
      { title: "SMS Master",            path: "smsCredential",        permission: "smsCredential",        icon: <MdSms />,             heading: false },
      { title: "Firebase Setup",        path: "firebaseSetup",        permission: "firebaseSetup",        icon: <VscActivateBreakpoints />, heading: false },

      { title: "Main", heading: true },
      { title: "Admin Users",           path: "adminUsers",           permission: "adminUsers",           icon: <CiUser />,            heading: false },
      { title: "Admin Roles",           path: "adminRoles",           permission: "adminRoles",           icon: <HiUserGroup />,       heading: false },
      { title: "Industry Master",       path: "industryMaster",       permission: "industryMaster",       icon: <FaIndustry />,        heading: false },
      { title: "App Users",             path: "appUsers",             permission: "appUsers",             icon: <RiProfileFill />,     heading: false },
      { title: "Client Theme",          path: "vendorTheme",          permission: "vendorTheme",          icon: <RiProfileFill />,     heading: false },
      { title: "Client Setup",          path: "basicSetup",           permission: "basicSetup",           icon: <RiListSettingsLine />,heading: false },
      { title: "Match Rules",           path: "matchRulesConfiguration", permission: "matchRulesConfiguration", icon: <RiListSettingsLine />, heading: false },
      { title: "Add On Features",       path: "rulesAndFeatures",     permission: "rulesAndFeatures",     icon: <RiListSettingsLine />,heading: false },
      { title: "Workflow Setup",        path: "workflowSetup",        permission: "workflowSetup",        icon: <VscDiffAdded />,      heading: false },
      { title: "App Dashboard",         path: "appDashboard",         permission: "appDashboard",         icon: <RiListSettingsLine />,heading: false },
      { title: "App Menu",              path: "appMenu",              permission: "appMenu",              icon: <RiListSettingsLine />,heading: false },
      { title: "Program Setup",         path: "program",              permission: "program",              icon: <VscActivateBreakpoints />, heading: false },
      { title: "Form Setup",            path: "formsetup",            permission: "formsetup",            icon: <MdAssignmentAdd />,   heading: false },
      { title: "Form Template",         path: "formTemplate",         permission: "formTemplate",         icon: <AiOutlineForm />,     heading: false },
      { title: "Employee Setup",        path: "employee-setup",       permission: "employeeSetup",        icon: <CiUser />,            heading: false },
      
      
      { title: "Other Options", heading: true },
      { title: "Uom Keys",              path: "uomKeys",              permission: "uomKeys",              icon: <RiListSettingsLine />,heading: false },
      { title: "Email Master",          path: "emailCredential",      permission: "emailCredential",      icon: <AiOutlineMail />,     heading: false },
      { title: "Notification Template", path: "notificationTemplate", permission: "notificationTemplate", icon: <IoIosNotifications />,heading: false },
      { title: "Tenant Dashboard Setup",path: "tenantWebDashboard",   permission: "tenantWebDashboard",   icon: <VscDiffAdded />,      heading: false },
      { title: "Pincode Master",        path: "pincode-master",       permission: "pincodeMaster",        icon: <MdMapsHomeWork />,    heading: false },
      { title: "Tenant Wallet",         path: "tenantWallet",         permission: "tenantWallet",         icon: <MdMapsHomeWork />,    heading: false },
      { title: "App Downtime",          path: "appDowntime",          permission: "appDowntime",          icon: <FiClock />,           heading: false },
      { title: "Loyalty Cache",         path: "loyaltyCache",         permission: "loyaltyCache",         icon: <MdRefresh />,         heading: false },
      { title: "Billing Cycle",         path: "billing-cycle",        permission: "billingCycle",         icon: <FiClock />,           heading: false },
      { title: "Change Admin Password", path: "changeAdminPassword", permission: "changeAdminPassword", icon: <RiLockPasswordLine />, heading: false },

      { title: "SupplyBeam", heading: true },
      { title: "SupplyBeam Locations",  path: "supplyBeamLocations",  permission: "supplyBeamLocations",  icon: <RiListSettingsLine />,heading: false },
      { title: "SupplyBeam Tenant",  path: "tenant",  permission: "supplyBeamTenant",  icon: <RiListSettingsLine />,heading: false },
      
    ],
  };

  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <a href=" " className="sidebar-brand">
          Gene<span></span>fied
        </a>
        <div className="sidebar-toggler not-active">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className="sidebar-body">
        <ul className="nav">
          {(() => {
            const isFinanceOnly = sessionStorage.getItem("finance_only") === "true";
            const rawItems = isFinanceOnly
              ? sidebarOptions.item.filter((item) => item.path === "tenantWallet")
              : sidebarOptions.item.filter((item) => {
                  if (item.heading) return true;
                  return hasAdminPermission(item.permission);
                });
            const items = rawItems.filter((item, index, array) => {
              if (item.heading) {
                const nextItem = array[index + 1];
                return nextItem && !nextItem.heading;
              }
              return true;
            });
            return items.map((item, idx) => {
            if (item.heading) {
              return (
                <li className="nav-item nav-category" key={idx}>
                  {item.title}
                </li>
              );
            } else
              return (
                <li
                  className={
                    item.path == pathname ? " nav-item active " : "nav-item"
                  }
                  key={idx}
                >
                  <Link to={item.path} className="nav-link">
                    {item.icon}
                    <span className="link-title"> {item.title}</span>
                  </Link>
                </li>
              );
          });
          })()}
          <li className="nav-item">
            <div to="printQr" className="nav-link">
              <BiLogOut />
              <span className="link-title" onClick={logout}>
                Logout
              </span>
            </div>
          </li>

          {/* <li className="nav-item">
            <Link to="dwan" className="nav-link">
              <MdSms />
              <span className="link-title">dwan</span>
            </Link>
          </li> */}

          {/*      
     <li className="nav-item nav-category">Product</li>

          <li className="nav-item">
            <Link to="productCategory" className="nav-link">
              <span className="link-title">Product Category</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="productSubCategory" className="nav-link">
              <span className="link-title">Product Sub Category</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="addProd" className="nav-link">
              <span className="link-title">Add Product</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="allProducts" className="nav-link">
              <span className="link-title">All Products</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="batchCreation" className="nav-link">
              <span className="link-title">Batch Creation</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="generateQr" className="nav-link">
              <span className="link-title">QR Code Generation</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="printQr" className="nav-link">
              <span className="link-title">QR Code Print</span>
            </Link>
          </li>

  */}
        </ul>
      </div>
    </nav>
  );
}
